import {
    ADD_TENANT, UPDATE_TENANT, DELETE_TENANT, FETCH_TENANTS, FETCH_PROPERTY_TENANTS, GET_TENANT_IN_UNIT, SHIFT_TENANT, FETCH_TENANT_DATA
} from './actionTypes';


const fetchTenants = (
    params = { propertyIds:[], archived:true, searchText: "",
        maxBalance: null, minBalance:null, daysToLeaseExpiry:0, offset:"", searchText:"", limit:50
    },
    appendData=false
) => {
     return ({
         type: FETCH_TENANTS,
         payload: {
             archived: true,
             appendData,
             ...params
         }
     })
}

const fetchPropertyTenants = (params) => {
    const defaultParams = {propertyIds: [], searchText: ""};
    const { propertyIds, searchText } = { ...defaultParams, ...params };
    return ({
        type: FETCH_PROPERTY_TENANTS,
        payload: {
            propertyIds, searchText
        }
    })
}

const fetchTenantData = (tenantId) => {
    return ({
        type: FETCH_TENANT_DATA,
        payload: {
            tenantId
        },
        errors: null
    })
}

const getTenantInUnit = (unitId) => ({
    type: GET_TENANT_IN_UNIT,
    payload: {
        unitId
    },
    errors: null
});

const addTenant = (payload) => ({
        type: ADD_TENANT,
        payload,
        errors: null
});

const updateTenant = (payload) => ({
        type:  UPDATE_TENANT,
        payload,
        errors: null
});

const deleteTenant = (propertyId, unitId, tenantId) => ({
    type: DELETE_TENANT,
    payload: {
        propertyId, unitId, tenantId
    },
    errors: null
});

const shiftTenant = (tenantId, unitId) => ({
    type: SHIFT_TENANT,
    payload: {
        tenantId, unitId
    },
    errors: null
});

export {
    addTenant, updateTenant, deleteTenant, fetchTenants,
    fetchPropertyTenants, getTenantInUnit, shiftTenant, fetchTenantData
};
